"use client";

import { useAppDispatch, useAppStore } from "@/redux/hooks";
import { setVideoData, setDevice, setVideoSlug } from "@/components/VideoPage/redux/slice";

const useSyncVideoData = ({ VideoData, ua, slug }) => {
  const dispatch = useAppDispatch();
  const store: any = useAppStore();

  if (store?.getState()?.video?.videoSlug === slug) {
    return;
  } else {
    dispatch(setVideoData(VideoData));
    dispatch(setDevice(ua));
    dispatch(setVideoSlug(slug));
  }
};

export { useSyncVideoData };
